import axios, { AxiosResponse, HttpStatusCode } from 'axios';
import axiosRetry, { isNetworkOrIdempotentRequestError } from 'axios-retry';
import { AccessTokenApiModel } from '../../../types/models/access-token.model';
import { RefreshTokenApiRequest } from '../../../types/requests/authentication/refresh-token.request';

const accessTokenString = window.localStorage.getItem('accessToken');
const { accessToken, refreshToken }: AccessTokenApiModel = accessTokenString ? JSON.parse(accessTokenString) : {};

export const client = axios.create({
  baseURL: `/api/v1`,
  headers: { Authorization: accessToken ? `Bearer ${accessToken}` : '' },
});

axiosRetry(client, {
  retries: 1,
  retryDelay: (retryCount, error) => error.response?.headers['retry-after'] ?? retryCount * 1000,
  retryCondition: (error) =>
    isNetworkOrIdempotentRequestError(error) ||
    error.response?.status === HttpStatusCode.TooManyRequests ||
    error.response?.status === HttpStatusCode.Unauthorized,
  onRetry: async (_retryCount, error, request) => {
    if (error.response?.status === HttpStatusCode.Unauthorized && refreshToken) {
      const { data } = await axios.post<
        AccessTokenApiModel,
        AxiosResponse<AccessTokenApiModel>,
        RefreshTokenApiRequest
      >('/api/v1/authentication/token', { refreshToken });
      window.localStorage.setItem('accessToken', JSON.stringify(data));
      client.defaults.headers.Authorization = `Bearer ${data.accessToken}`;
      if (request.headers) {
        request.headers.Authorization = `Bearer ${data.accessToken}`;
      }
    }
  },
});
